import { gsap } from "gsap";

export default function loopimg() {
  // loop animation
  // --------------------------------
  const initLoop = () => {
    const loop = document.getElementById("loop_js");

    function setSpeed(loopAnim) {
      var speed = 120; // 流れるスピード
      let percent = -66.6666;
      loopAnim.to(loop, speed, { ease: "power1.out", xPercent: percent }).to(loop, 0, { ease: "power1.out", x: 0 });
    }

    if (loop != undefined && loop != null) {
      //タイムラインを作成
      const loopAnim = gsap.timeline({
        repeat: -1, //繰り返し無制限
      });
      //画像を複製してdiv内に挿入
      let loopItem = (window.innerWidth, loop.children[0]);
      let slider_size = loop.children[0].clientWidth * 3;
      loop.style.width = parseInt(slider_size) + "px";
      loop.appendChild(loopItem.cloneNode(true));
      loop.appendChild(loopItem.cloneNode(true));
      loop.appendChild(loopItem.cloneNode(true));
      setSpeed(loopAnim);
    }
  };

  window.addEventListener("load", () => {
    initLoop();
  });
}
